export default __webpack_public_path__ + "static/media/dot.7612457b.svg";